import { Priority } from '../interfaces/priority';

export class After implements Priority {
  priority(): number {
    return 1;
  }
}

export class Before implements Priority {
  priority(): number {
    return -1;
  }
}
